export const SURVEY_TOOL_SESSION_HEADER = "X-SurveyTool-Session";
export const SLASH_API_SLASH = "/api/";
export const OAS3_ROOT = "/openapi"; // Path to the 'openapi' (sibling to cldr-apps). Needs to be a host-relative URL.

const THIS_YEAR = new Date().getFullYear();

/** Copyright */
export const COPYRIGHT = `© 2004-${THIS_YEAR} Unicode, Inc. Unicode and the Unicode Logo are registered trademarks of Unicode, Inc. in the U.S. and other countries.`;
/** "See …." */
export const TERMS_OF_USE_URL = `https://www.unicode.org/copyright.html`;

export const VOTE_FOR_MISSING = `🚫🚫🚫`; // see VoteResolver.VOTE_FOR_MISSING
